
export type MSelectOption<Value = null, Id extends string = string> = {
  id: Id;
  label: string | JSX.Element;
  isDisabled?: boolean;
} & (Value extends null ? Record<never, never> : { value: Value });

export type MReactSelectOption = {
  label: string | JSX.Element;
  value: string;
  isDisabled?: boolean;
  __isNew__?: boolean;
};

export type MSelectChangeData<Value = null, Id extends string = string, IsCreatable extends boolean = false> = MSelectOption<Value, Id> &
  (IsCreatable extends true
    ? {
        isCreated?: boolean;
      }
    : Record<never, never>);


export enum MSelectOptionType {
  SelectAll = 'select-all',
  UnselectAll = 'unselect-all',
}